import { Navigation, Pagination } from 'swiper/js/swiper.esm';
import MixPanelWrapper from 'js/servises/MixPanelWrapper';
class HomeSliderService {
    stopOnHover = (parentClass, slider) => {
        const swiperContainer = document.querySelector(`.${parentClass} .swiper-container`);

        if (!swiperContainer || !slider) {
            return;
        }

        const handleMouseEnter = () => {
            slider.autoplay.stop();
        };

        const handleMouseLeave = () => {
            slider.autoplay.start();
        };

        swiperContainer.addEventListener('mouseenter', handleMouseEnter);
        swiperContainer.addEventListener('mouseleave', handleMouseLeave);

        return () => {
            swiperContainer.removeEventListener('mouseenter', handleMouseEnter);
            swiperContainer.removeEventListener('mouseleave', handleMouseLeave);
        };
    };

    getParams = (setSlider, sliderClass, secondWrapClass, bulletsClass, autoPlay = false, loop = true) => {
        const params:any = {
            slidesPerView: 'auto',
            spaceBetween: 60,
            loop,
            autoplay: false,
            modules: [Pagination, Navigation],

            pagination: {
                el: `.${sliderClass} > .${secondWrapClass} > .${bulletsClass}`,
                clickable: true,
                renderBullet: (index, className) => `<span class="${className}"></span>`
            },
            getSwiper: setSlider
        };
        if (autoPlay) {
            params.speed = 1000;
            params.autoplay =  {
                delay: 3000,
                disableOnInteraction: false
            };
        }

        return params;
    };

    setSliderBulletsClickEvent = (paginationBullets, value, section) =>
        Object?.keys(paginationBullets)?.forEach((key) => {
        if (key !== 'length') {
            const bullet = paginationBullets[key];
            bullet?.addEventListener('click', async () => {
                const eventData:any = {
                    category: 'Home page',
                    section
                };
                if (value) {
                    eventData.value = value;
                }
                await MixPanelWrapper.TrackEvent(
                    'Slider Component is clicked on',
                    eventData
                );
            });
        }
    });
}

export default new HomeSliderService();
